export const LIST_NOTIFICATIONS_REQUESTED = 'LIST_NOTIFICATIONS_REQUESTED';
export const LIST_NOTIFICATIONS_COMPLETED = 'LIST_NOTIFICATIONS_COMPLETED';
export const LIST_NOTIFICATIONS_FAILED = 'LIST_NOTIFICATIONS_FAILED';
export const RESET_LIST_NOTIFICATIONS_REQUESTED =
  'RESET_LIST_NOTIFICATIONS_REQUESTED';
export const RESET_LIST_NOTIFICATIONS_COMPLETED =
  'RESET_LIST_NOTIFICATIONS_COMPLETED';
export const CLEARTOAST_NOTIFICATIONS_REQUESTED =
  'CLEARTOAST_NOTIFICATIONS_REQUESTED';
export const CLEARTOAST_NOTIFCATIONS_ABORTED =
  'CLEARTOAST_NOTIFCATIONS_ABORTED';
export const CLEARTOAST_NOTIFICATIONS_COMPLETED =
  'CLEARTOAST_NOTIFICATIONS_COMPLETED';
export const CLEARTOAST_NOTIFICATIONS_FAILED =
  'CLEARTOAST_NOTIFICATIONS_FAILED';
export const READ_NOTIFICATIONS_REQUESTED = 'READ_NOTIFICATIONS_REQUESTED';
export const READ_NOTIFCATIONS_ABORTED = 'READ_NOTIFCATIONS_ABORTED';
export const READ_NOTIFICATIONS_COMPLETED = 'READ_NOTIFICATIONS_COMPLETED';
export const READ_NOTIFICATIONS_FAILED = 'READ_NOTIFICATIONS_FAILED';
export const OPENED_NOTIFICATION_REQUESTED = 'OPENED_NOTIFICATION_REQUESTED';
export const OPENED_NOTIFICATION_COMPLETED = 'OPENED_NOTIFICATION_COMPLETED';
export const OPENED_NOTIFICATION_FAILED = 'OPENED_NOTIFICATION_FAILED';
export const OPENED_NOTIFCATIONS_ABORTED = 'OPENED_NOTIFCATIONS_ABORTED';
